// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"ea89bdeb","453":"4c4006d3","947":"c49e18bf"}[chunkId] + ".chunk.js";
};